<template>
  <div class="home">
    <hero-unit></hero-unit>
    <home-summary></home-summary>
    <time-line></time-line>
    <home-blocks></home-blocks>
    <partners></partners>
    <site-footer></site-footer>
  </div>
</template>

<script>
import heroUnit from '@/components/hero'
import timeLine from '@/components/timeline'
import homeBlocks from '@/components/blocks'
import partners from '@/components/partners'
import principals from '@/components/principals'
import siteFooter from '@/components/footer'
import homeSummary from '@/components/summary'
export default {
  name: 'home',
  components: {
    heroUnit,
    homeSummary,
    timeLine,
    homeBlocks,
    partners,
    principals,
    siteFooter
  }
}
</script>
<style lang="scss" scoped>
.home {
  max-width: 100%;
}
</style>

